// extracted by mini-css-extract-plugin
module.exports = {"articleCard":"Card_articleCard__zsofQ","summary":"Card_summary__ubY8x","author":"Card_author__VJ_i9","date":"Card_date__VRi8I"};